import { useState, useEffect } from 'react';

import { _SignAndApprovalPanel } from '../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { SelectTypeProcees } from '../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees';
import useModal, { MODAL_SM } from '../../theme/Component/hooks/useModal';
import { Modal } from '../../theme/Component/Modal';
import { toast } from 'react-toastify';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    placeHolder?: string;
}

export const SingPanelEditor = ({ idSelector, onChange, label }: Props) => {

    const { instance, setBean, bean, lista, setLista, handleChange } = useDataBean(_SignAndApprovalPanel);
    const [processType, setProcessType] = useState<any>(null);
    const [placeHolder, setPlaceHolder] = useState<string>('');
    const modal = useModal("Panel de Firma", MODAL_SM);
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
        getLista();
    }, [])

    useEffect(() => {
        getLista();
    }, [processType])

    const setValue = (e: any) => {
        setID(parseInt(e));

    }



    const getLista = () => {

        instance.getSignAndApprovalPanelCatalog(processType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const setPanel = () => {
        if (id) {
            onChange?.(id);
            const holder = lista.filter(item => item.DataBeanProperties.IDSignAndApprovalPanel == id);
            console.log(holder);

            if (holder.length > 0) {
                setPlaceHolder((holder[0].DataBeanProperties.Code ?? '') + " - " + (holder[0].DataBeanProperties.Name ?? ''));
            }
            modal.close();
        } else {
            toast.error("Panel de firmas no valido")
        }
    }

    return (
        <>
            <label>{label ?? "Panel de Firma"}</label>
            <input type="text" name="panel" id="panelfirma" placeholder={placeHolder ?? ''} className='form-control' readOnly onClick={() => { modal.open() }} />
            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={setPanel} onSubmitLabel='Seleccionar'>
                <div className="row">
                    <div className="col">
                        <SelectTypeProcees label="Tipo de Proceso" idSelector={processType} onChange={(e) => setProcessType(e)} />
                        <label>Flujos de Aprobación y Firma de Documentos y Procesos:</label>
                        <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                            <option>...</option>
                            {lista &&
                                lista.map((item: any, index: number) => {
                                    return (
                                        <option key={index} value={item.DataBeanProperties.IDSignAndApprovalPanel} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
            </Modal>
        </>
    )
}